<form name="form" #importWizardForm="ngForm" class="form-horizontal">
    <ng-container *ngIf="(currentStep$ | async) as currentStep">
        <div class="mon-dialog-header">
            <mon-page-header header="{{ getStepTitle(currentStep) }}"></mon-page-header>
        </div>

        <div class="mon-dialog-body-with-footer">
            <!-- Step Indicator - Clean and Inline -->
            <div class="d-flex justify-content-between align-items-center px-3 pt-3 pb-2 border-bottom">
                <div class="d-flex align-items-center">
                    <span class="badge badge-primary me-2">{{ getStepNumber(currentStep) }}</span>
                    <span class="text-dark fw-bold">{{ getStepTitle(currentStep) }}</span>
                </div>
                <div class="d-flex align-items-center">
                    <small class="text-muted me-2">{{ getStepNumber(currentStep) }} of {{ getTotalSteps() }}</small>
                    <div class="progress" style="width: 100px; height: 6px;">
                        <div 
                            class="progress-bar bg-primary" 
                            role="progressbar" 
                            [style.width.%]="(getStepNumber(currentStep) / getTotalSteps()) * 100">
                        </div>
                    </div>
                </div>
            </div>
            <!-- Error Display -->
            <div class="alert alert-danger mx-3 mt-3" *ngIf="error">
                <i class="fas fa-exclamation-triangle me-2"></i>
                {{ error }}
            </div>

            <!-- Step 1: Upload -->
            <div class="card monsido-panel mt-3 mx-3" *ngIf="currentStep === WizardStep.UPLOAD">
                <div class="card-header">
                    <h3 class="font-weight-300" translate>Upload JSON File</h3>
                </div>
                <div class="card-body">
                    <mon-import-wizard-upload 
                        [loading]="loading"
                        (fileUploaded)="onFileUploaded($event)">
                    </mon-import-wizard-upload>
                </div>
            </div>

            <!-- Step 2: Configure -->
            <div class="card monsido-panel mt-3 mx-3" *ngIf="currentStep === WizardStep.CONFIGURE">
                <div class="card-header">
                    <h3 class="font-weight-300" translate>Import Configuration</h3>
                </div>
                <div class="card-body">
                    <mon-import-wizard-configure
                        [configuration]="configuration$ | async"
                        (configurationUpdated)="onConfigurationUpdated($event)">
                    </mon-import-wizard-configure>
                </div>
            </div>

            <!-- Step 3: Confirm -->
            <div class="card monsido-panel mt-3 mx-3" *ngIf="currentStep === WizardStep.CONFIRM">
                <div class="card-header">
                    <h3 class="font-weight-300" translate>Confirm Import</h3>
                </div>
                <div class="card-body">
                    <mon-import-wizard-confirm
                        [parsedFile]="parsedFile$ | async"
                        [configuration]="configuration$ | async">
                    </mon-import-wizard-confirm>
                </div>
            </div>

            <!-- Step 4: Progress -->
            <div class="card monsido-panel mt-3 mx-3" *ngIf="currentStep === WizardStep.PROGRESS">
                <div class="card-header">
                    <h3 class="font-weight-300" translate>Importing Domains</h3>
                </div>
                <div class="card-body">
                    <mon-import-wizard-progress
                        [progress]="progress$ | async">
                    </mon-import-wizard-progress>
                </div>
            </div>

            <!-- Step 5: Results -->
            <div class="card monsido-panel mt-3 mx-3" *ngIf="currentStep === WizardStep.RESULTS">
                <div class="card-header">
                    <h3 class="font-weight-300" translate>Import Results</h3>
                </div>
                <div class="card-body">
                    <mon-import-wizard-results
                        [importSummary]="importSummary$ | async"
                        (downloadErrorReport)="downloadErrorReport()">
                    </mon-import-wizard-results>
                </div>
            </div>
        </div>

        <!-- Dialog Footer with Navigation -->
        <div class="mon-dialog-footer d-flex justify-content-between">
            <div>
                <!-- Back Button -->
                <button
                    type="button"
                    class="btn btn-outline-secondary"
                    *ngIf="canGoBack(currentStep)"
                    [disabled]="loading"
                    (click)="previousStep()"
                    translate>
                    Back
                </button>
            </div>

            <div>
                <!-- Next Button for Upload and Configure Steps -->
                <button
                    type="button"
                    class="btn btn-primary me-2"
                    *ngIf="currentStep === WizardStep.UPLOAD || currentStep === WizardStep.CONFIGURE"
                    [disabled]="!canProceedToNext(currentStep, parsedFile$ | async) || loading"
                    (click)="nextStep()"
                    translate>
                    Next
                </button>

                <!-- Start Import Button for Confirm Step -->
                <button
                    type="button"
                    class="btn btn-success me-2"
                    *ngIf="currentStep === WizardStep.CONFIRM"
                    [disabled]="!canProceedToNext(currentStep, parsedFile$ | async) || loading"
                    (click)="startImport()"
                    data-test="start-import-button">
                    <i class="fas fa-upload me-1" *ngIf="!loading"></i>
                    <i class="fas fa-spinner fa-spin me-1" *ngIf="loading"></i>
                    <span translate>Start Import</span>
                </button>

                <!-- Close Button for Results Step -->
                <button
                    type="button"
                    class="btn btn-primary me-2"
                    *ngIf="currentStep === WizardStep.RESULTS"
                    (click)="closeWithRefresh()"
                    translate>
                    Done
                </button>

                <!-- Cancel Button (always visible except during progress) -->
                <button
                    type="button"
                    class="btn btn-secondary"
                    *ngIf="currentStep !== WizardStep.PROGRESS"
                    [disabled]="loading"
                    (click)="close()"
                    translate>
                    Cancel
                </button>
            </div>
        </div>
    </ng-container>
</form>